import React, { useState } from 'react';
import '../css/HomeFAQ.css';

const HomeFAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqData = [
    {
      question: "What is the minimum qualification required for Fire & Safety courses?",
      answer: "You can apply after completing your 10th, 12th, or Graduation. Greenfield Academy offers foundation to advanced level structural programs based on your educational background."
    },
    {
      question: "Are NEBOSH certificates globally recognized?",
      answer: "Yes, absolutely! NEBOSH certificates are highly respected and recognized by global bodies and employers across the UK, USA, Gulf countries, and worldwide as a standard for HSE roles."
    },
    {
      question: "Do you provide 100% practical training?",
      answer: "Yes, we focus heavily on real-world industry exposure. Our training includes live practical demonstrations, industrial site visits, fire hydrant operations, and simulation room training."
    },
    {
      question: "How does the dedicated placement cell work?",
      answer: "Our placement cell has tie-ups with 200+ top industrial companies. We assist you with complete interview preparation, resume building, and actively schedule drives for jobs across India and Gulf countries."
    },
    {
      question: "Can I attend these safety courses online?",
      answer: "Yes, we provide top-grade safety courses online at all levels with excellent education faculty to guide you through, along with flexible schedules for working professionals."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="gfi-faq-section">
      <div className="gfi-faq-container">
        
        {/* SECTION HEADER */}
        <div className="gfi-faq-header">
          <span className="gfi-faq-badge">HAVE QUESTIONS?</span>
          <h2 className="gfi-faq-title">Frequently Asked Questions</h2>
          <p className="gfi-faq-subtitle">
            Clear your doubts regarding our safety qualifications, course eligibility, and placement tracks.
          </p>
        </div>

        {/* ACCORDION ACCUMULATOR LIST */}
        <div className="gfi-faq-accordion-wrapper">
          {faqData.map((faq, index) => {
            const isOpen = activeIndex === index;
            return (
              <div 
                key={index} 
                className={`gfi-faq-item ${isOpen ? 'active-faq' : ''}`}
                onClick={() => toggleFAQ(index)}
              >
                {/* Accordion Trigger Title Header Row */}
                <div className="gfi-faq-question-row">
                  <h3 className="gfi-faq-question-text">{faq.question}</h3>
                  <span className="gfi-faq-toggle-icon">
                    {isOpen ? '−' : '+'}
                  </span>
                </div>
                
                {/* Smooth Animated Content Hidden Box Area */}
                <div className="gfi-faq-answer-block">
                  <p className="gfi-faq-answer-text">{faq.answer}</p>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
};

export default HomeFAQ;